/*
 * Public API Surface of report-export-view
 */
export { ReportExportViewService } from './lib/report-export-view.service';
export { InterpolatedBlueprintService } from './lib/interpolated-blueprint.service';
export { InterpolationResolverService } from './lib/interpolation-resolver.service';
export { DynamicLocaleService } from './lib/dynamic-locale.service';
export { ReportExportViewModule } from './lib/report-export-view.module';
export { ReportBluePrintInterpolationService } from './lib/report-blueprint-interpolation.service';
export { REPORT_EXPORT_CONFIGS_TOKEN } from './lib/report-export-view.token';
export { L10N_REPORTS_TRANSLATION_PROVIDERS } from './lib/l10n-config';
export { ReportImagesService } from './lib/report-images.service';
export { ReportAllRecordsImage } from './lib/models/template.model';
export { TemplateDynamicService } from './lib/template-dynamic.service';
export { ViewTemplate } from './lib/models/template.model';
// models
export { TEMPLATE_CONFIGURATIONS } from './lib/shared/templates/template-display-fn.const';
export { TemplateField, MappedTemplateField, ResolvedTemplateField } from './lib/models/template.model';
export {
  ReportInfo,
  ReportView,
  ReportRecord,
  EditingBoxConfigItem,
  RecordUpdateEmission,
} from './lib/models/report.model';
export {
  BlueprintBase,
  ColumnBase,
  GroupBase,
  InterpolatedBlueprint,
  CoverPageBlueprint,
  CoverBlueprint,
  Layout,
} from './lib/models/blueprint.model';

export { StackingTenants, StackingFloorTenants } from './lib/models/stackingplan.model';

export * from './lib/models/windward-blueprint.model';

// utils
export {
  IMAGE_FIELD_ID,
  ADDITIONAL_IMAGE_FIELD_ID,
  IMAGE_STATIC,
  groupByProperty,
  groupByPropertyGroups,
  sortByParentPosition,
  toCondensedSection,
  miqColorRoulette,
  rouletter,
  mapImageColorToRecordItems,
} from './lib/shared';
export {
  PACIFIC_TEMPLATE_IDS,
  CHINA_SUMMARY_MAPSIZE_ON_RECORDCOUNT,
  PACIFIC_AVAILABILITIES_IDS,
  INDIA_CUSTOM_GROUP_TEMPLATE_IDS,
} from './lib/shared/templates/template-blueprints.const';

// Add exported components and pipes in the NgModule and necessary for ng9
export * from './lib/shared/pipes/report-field-formatter.pipe';
export * from './lib/shared/pipes/report-label-formatter.pipe';
export { FileSizePipe } from './lib/shared/pipes/file-size.pipe';
export { NotificationService } from './lib/shared/services/notification.service';
export { LocaleKeys } from './lib/shared/templates/utils/template-display-sort-order.const';
export { Entities } from './lib/shared/templates/config/common';
export { Contact as LibraryContact, CONTACT_NAME_TYPES } from './lib/views/presentation-dynamic-view/dynamic-contacts/dynamic-contacts.model';
export * from './lib/views/presentation-view/presentation-view.component';
export * from './lib/views/table-view/table-view.component';
export * from './lib/views/comparison-view/comparison-view.component';
export * from './lib/views/condensed-view/condensed-view.component';
export * from './lib/views/presentation-dynamic-view/presentation-dynamic-view.component';
export * from './lib/views/summary-view/summary-view.component';
export * from './lib/shared/pipes/field-visible.pipe';
export * from './lib/shared/pipes/label-parser.pipe';
export * from './lib/views/data-view/data-view.component';
export * from './lib/views/data-view/data-view-formatter.pipe';
export * from './lib/views/data-view/data-view-route.pipe';
export * from './lib/views/development-pipeline-view/development-pipeline-view.component';
export * from './lib/views/tag-output-view/tag-output-view.component';
export * from './lib/views/presentation-view/record-body/floor-plan/floor-plan.component';
export * from './lib/shared/pipes/date.pipe';
